import { z } from 'zod'

export type SiteSchema = z.infer<typeof siteSchema>
export const siteSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  address: z.string(),
  orgID: z.string(),
  internalID: z.string().optional(),
  coordinates: z
    .object({
      lat: z.number(),
      lng: z.number()
    })
    .nullable(),
  droughtIncidentEnabled: z.boolean()
})

export type CreateSiteSchema = z.infer<typeof createSiteSchema>
export const createSiteSchema = siteSchema.omit({ id: true, droughtIncidentEnabled: true })
